/* eslint-disable @typescript-eslint/ban-ts-comment */
/** @jsx jsx */
import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import React, { memo } from "react";
import ReactMarkdown from "react-markdown";
import { jsx } from "theme-ui";
import { Styled } from "theme-ui";

import Lead from "../Lead";

const Markdown: React.FC<{ children?: string | null }> = ({ children }) =>
  children ? (
    <ReactMarkdown
      source={children}
      renderers={{
        blockquote: Lead,
        paragraph: Styled.p,
        list: Styled.ul,
        listItem: Styled.li,
        emphasis: Styled.em,
        link: (
          props: React.AnchorHTMLAttributes<HTMLAnchorElement>
        ): React.ReactElement => {
          const isLocal = props.href?.[0] === "/";

          if (isLocal) {
            // @ts-ignore
            return <Styled.a {...props} as={Link} to={props.href} />;
          }

          return (
            <Styled.a
              {...props}
              as={OutboundLink}
              target={"_blank"}
              rel={"noopener noreferrer"}
            />
          );
        },
        heading: (
          props: React.HTMLAttributes<HTMLHeadingElement> & { level: number }
        ): React.ReactElement => {
          switch (props.level) {
            case 1:
              return <Styled.h1 {...props} />;
            case 2:
              return <Styled.h2 {...props} />;
            case 3:
              return <Styled.h3 {...props} />;
            case 4:
              return <Styled.h4 {...props} />;
            case 5:
              return <Styled.h6 {...props} />;
            case 6:
              return <Styled.h6 {...props} />;
            default:
              return <Styled.p {...props} />;
          }
        },
      }}
    />
  ) : null;

export default memo(Markdown);
